import {Component, Inject, Input, OnInit, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {
  ProductListInterface,
  ProductSingleInterface, RateResourceInterface,
  ShopSimpleInterface
} from "@interfaces/catalog/products.interface";
import {ClearButtonComponent} from "../../global/clear-button/clear-button.component";
import {DecimalPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {ReplaceToCommaPipe} from "../../../pipes/string-methods/replace-to-comma.pipe";
import {RequestMethodsService} from "@services/request/request-methods.service";
import {ReviewInterface, ReviewPaginationInterface} from "@interfaces/components/review.interface";
import {ToLocalDatePipe} from "../../../pipes/date-methodes/to-local-date.pipe";
import {ResourceGalleryComponent} from "../../global/resource-gallery/resource-gallery.component";
import {ResourceUrlInterface} from "@interfaces/components/resource-url.interface";

@Component({
  selector: 'app-product-and-shop-reviews',
  standalone: true,
  imports: [
    ClearButtonComponent,
    NgIf,
    DecimalPipe,
    ReplaceToCommaPipe,
    NgClass,
    NgForOf,
    ToLocalDatePipe
  ],
  templateUrl: './product-and-shop-reviews.component.html',
  styleUrl: './product-and-shop-reviews.component.scss'
})
export class ProductAndShopReviewsComponent implements OnInit {
  @Input() data!: {shop: ShopSimpleInterface, product?: ProductSingleInterface, type?: string}
  @Input() fromDialog = true;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public info: {shop: ShopSimpleInterface, product?: ProductSingleInterface, type?: string},
    private dialogRef: MatDialogRef<ProductAndShopReviewsComponent>,
    private requestService: RequestMethodsService,
    private dialog: MatDialog
  ) {
    if (this.info) {
      this.data = this.info;
    }
  }

  reviews: Array<ReviewInterface> = [];

  ngOnInit(): void {
    this.getDetails();
  }

  openGallery(resources: Array<RateResourceInterface>): void {
    this.dialog.open(ResourceGalleryComponent, {
      panelClass: 'full-screen-dialog',
      backdropClass: 'custom-dialog-backdrop',
      data: { items: resources.map(
        (resource: RateResourceInterface): ResourceUrlInterface => {
          return {resourceUrl: resource.resourceUrl, resourceType: resource.resourceType}
        }),
        startIndex: 0
      },
    });
  }

  getDetails(): void {
    let params;
    if (this.data.product) {
      params = `productShopId=${this.data.product.id}`
    } else {
      params = `shopId=${this.data.shop.id}`
    }
    this.requestService.post(`orders/review/filter?${params}&page=1&size=50&direction=DESC`, {})
      .subscribe((response: ReviewPaginationInterface) => {
        this.reviews = response.content;
      })
  }

  close(): void {
    this.dialogRef.close()
  }

}
